// extracted by mini-css-extract-plugin
export var disabled = "_1h-a";
export var hierarchyLinkGray = "_1h-4";
export var hierarchyLinkUnderline = "_1h-3";
export var hierarchyPrimary = "_1h-0";
export var hierarchySecondary = "_1h-1";
export var hierarchyTertiary = "_1h-2";
export var pressed = "_1h-6";
export var themeAction = "_1h-5";
export var themeDestructive = "_1h-8";
export var themeNormal = "_1h-7";
export var themeSuccess = "_1h-9";